var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__parent-container flex flex-col",class:_vm.listClassContainer},[(!_vm.isMe)?_c('div',{class:_vm.listClassUsername},[_vm._v(_vm._s(_vm.username))]):_vm._e(),_c('div',{staticClass:"message__parent-content"},[_vm._v(_vm._s(_vm.messageParent.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }